module.exports = __webpack_public_path__ + "img/ic_injury_bl.5330b765.svg";